import * as React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccessibleIcon from "@mui/icons-material/Accessible";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import PhoneIcon from "@mui/icons-material/Phone";
import Chip from "@mui/material/Chip";

const formatWorkingHours = (workingHours) => {
  if (!workingHours) return '';

  const dias = {
    'segunda': 'Seg',
    'terca': 'Ter',
    'quarta': 'Qua',
    'quinta': 'Qui',
    'sexta': 'Sex',
    'sabado': 'Sáb',
    'domingo': 'Dom'
  };

  const ordemDias = ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'];

  return (
    <Box display="flex" flexWrap="wrap" gap={1}>
      {ordemDias
        .filter(day => workingHours[day] && workingHours[day].open && workingHours[day].close)
        .map(day => (
          <Chip
            key={day}
            size="small"
            label={`${dias[day]} ${workingHours[day].open}h-${workingHours[day].close}h`}
            sx={{ 
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
              '& .MuiChip-label': { 
                fontSize: '0.75rem' 
              }
            }}
          />
        ))}
    </Box>
  );
};

const formatPhone = (phone) => {
  if (!phone) return '';
  
  const numeros = phone.replace(/\D/g, '');
  
  if (numeros.length === 8) {
    return `${numeros.slice(0, 4)}-${numeros.slice(4)}`;
  } else if (numeros.length === 9) {
    return `${numeros.slice(0, 5)}-${numeros.slice(5)}`;
  } else if (numeros.length === 10) {
    return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 6)}-${numeros.slice(6)}`;
  } else if (numeros.length === 11) {
    return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 7)}-${numeros.slice(7)}`;
  } else if (numeros.length > 11) {
    return `+${numeros.slice(0, numeros.length-11)} (${numeros.slice(-11, -9)}) ${numeros.slice(-9, -4)}-${numeros.slice(-4)}`;
  }
  
  return phone;
};

export default function BloodBankCard({ bloodBank }) {
  return (
    <>
      <Paper
        elevation={3}
        sx={{
          px: 4,
          py: 2,
          width: "100%",
          maxWidth: { xs: "100%", sm: "600px", md: "800px" },
          margin: "0 auto",
        }}
      >
        <Box display="flex" alignItems="center" marginBottom={1}>
          <Typography display="flex" alignItems="center" variant="h5" gutterBottom>
            {bloodBank.name}&nbsp;&nbsp;&nbsp;
            <LocalParkingIcon color="secondary" sx={{ mr: 1 }}/>
            <AccessibleIcon color="secondary" sx={{ ml: 1 }}/>
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" marginBottom={1}>
          <LocationOnIcon color="secondary" />
          <Typography marginLeft={1}>{bloodBank.address}</Typography>
        </Box>
        <Box display="flex" alignItems="center" marginBottom={1}>
          <PhoneIcon color="secondary" />
          <Typography marginLeft={1}>{formatPhone(bloodBank.phone)}</Typography>
        </Box>
        <Box>
          <Box display="flex" alignItems="center" marginBottom={1}>
            <AccessTimeIcon color="secondary" fontSize="small" />
            <Typography marginLeft={1}>{formatWorkingHours(bloodBank.working_hours)}</Typography>
            
          </Box>
        </Box>
        <Box display="flex" alignItems="center" marginBottom={2}>
          <EditCalendarIcon color="secondary" />
          <Link href={bloodBank.scheduling_link} marginLeft={1} target="_blank" rel="noopener noreferrer">
            Link de agendamento
          </Link>
        </Box>
      </Paper>
    </>
  );
}
